<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>

    <div class="box-content">
      <!-- 大学直通车 -->
      <div class="box1">
        <textBar titles="大学直通车"></textBar>
        <div class="box1-content">
          <universityCarCards
            v-for="(item, index) in mydata.universityCar"
            :info="item"
            :key="index"
          ></universityCarCards>
        </div>
      </div>
      <!-- 超值推荐 -->
      <div class="box2">
        <textBar titles="超值推荐">
          <template #abc>
            <p
              class="check-more"
              style="cursor: pointer"
              @click="router.push({ path: '/layout/list/addedServices' })"
            >
              查看更多<el-icon><ArrowRight /></el-icon>
            </p>
          </template>
        </textBar>
        <div class="box2-content">
          <greatValueCards
            v-for="(item, index) in mydata.recommend_list"
            :key="index"
            :info="item"
            :path="item.path"
            :outPage="true"
          ></greatValueCards>
        </div>
      </div>
      <!-- 亲子园地 -->
      <div class="box3">
        <textBar titles="亲子园地">
          <template #abc>
            <p
              class="check-more"
              style="cursor: pointer"
              @click="router.push({ path: '/layout/list/parentChildGarden' })"
            >
              查看更多
              <el-icon><ArrowRight /></el-icon>
            </p>
          </template>
        </textBar>
        <div class="box3-content">
          <parentChildGardenCards
            :path="mydata.parentChildGarden_path"
            v-for="(item, index) in mydata.articleListArr"
            :key="index"
            :info="item"
          ></parentChildGardenCards>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
// import inputBox from "@/components/inputBox/index.vue";
import textBar from "@/components/textBar/index.vue";
import parentChildGardenCards from "@/components/parentChildGardenCards/index.vue";
import greatValueCards from "@/components/greatValueCards/index.vue";
import universityCarCards from "@/components/universityCarCards/index.vue";

// 引入接口
import { articleList } from "@/api/home/index.js";

// 引入接口
import { getUrlId } from "@/utils/slide.js";
// 引入接口
import { getMenuChildren } from "@/utils/slide.js";

// 引入淘题搜索接口
import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";

// 引入推荐列表接口（超值推荐）
import { getRecommendList } from "@/api/recommend/index.js";
import { dictKeyWord } from "@/utils/dict.js";

import { useRouter, useRoute } from "vue-router";
import { reactive } from "vue";

import { ArrowRight } from "@element-plus/icons-vue";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  universityCar: getMenuChildren("/layout/list/parentSchool").splice(0, 4),

  // car_path: "/layout/list/researchDetails",
  parentChildGarden_path: "/layout/list/parentChildGardenDetails",
  articleListArr: [], // 文章列表

  recommend_list: {}, //推荐列表

  form: {
    column_id: getUrlId(route.path), // 栏目id值
    // search: "", // 搜索查询
    // stage: "", //学段
    // theme: "", //主题
    // subject: "", //学科
  },
  // 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

// 获取文章列表
function articleListFn() {
  articleList({
    column_id: getUrlId("/layout/list/parentChildGarden"), // 栏目id值
  }).then((res) => {
    // console.log(4, res.data);
    mydata.articleListArr = res.data.list;
  });
}

// 调用函数
articleListFn();

//

////////////////////

// 超值推荐
function getBottomRecommendData() {
  // 调用接口
  // examSearchList({
  //   search: "", // 搜索查询
  //   grade_id: "", // 年级
  //   subject_id: "", //学科
  //   address_id: "", //地区
  //   type_id: "", //类型
  //   year_id: "", // 年份
  //   is_new: "", //是否最新（不传或者传0：否，1：是）
  //   is_recommended: "1", //是否推荐（不传或者传0：否，1：是）
  // }).then((res) => {
  //   mydata.recommend_list = res.data.list.map((item) => {
  //     // console.log( mydata.recommend_list,"超值推荐")
  //     // item.img_url = mydata.VUE_APP_BASE_HOST + item.image
  //     item.img_url = item.image;
  //     return item;
  //   });

  // });

  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord["超值推荐"];
  // 调用接口
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.recommend_list = res.data.list.map((item) => {
      // console.log( mydata.recommend_list,"超值推荐")
      // item.img_url = mydata.VUE_APP_BASE_HOST + item.image
      // item.img_url = item.image;
      item.img_url = /^http/.test(item.img_url)
        ? item.img_url
        : mydata.VUE_APP_BASE_HOST + item.img_url;
      item.path = item.buy_url_jd || item.buy_url;
      return item;
    });
  });
}
getBottomRecommendData();
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  // overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离
  overflow: visible;

  .check-more:hover {
    color: #009de0 !important;
  }

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ////////////////////
  .box-content {
    // width: 1200px;
    // height: 1223px;
    height: auto;
    margin: 0 auto;
    overflow: visible;
    // border: 1px solid red;
    // 大学直通车
    .box1 {
      width: 100%;
      // height: 336px;
      border: 1px solid transparent;
      // overflow: auto;

      /* 针对webkit内核浏览器 */
      .box1-content::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
        height: 0px;
      }

      .box1-content {
        width: 100%;
        padding: 0px 16px;
        display: flex;
        overflow-x: auto;

        .box-car {
          flex-shrink: 0;
          margin-right: 16px;
          // border:1px solid red;
        }
        .box-car:last-of-type {
          margin-right: 0px;
        }
      }
    }
    // 超值推荐
    .box2 {
      width: 100%;
      // height: 384px;
      height: auto;
      // border: 1px solid rgb(8, 245, 20);
      overflow: hidden;

      /* 针对webkit内核浏览器 */
      .box2-content::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
        height: 0px;
      }

      .box2-content {
        width: 100%;
        height: auto;
        // border: 1px solid rgb(255, 60, 0);
        display: flex;
        padding: 0px 16px;
        overflow-x: auto;

        //justify-content: space-between;

        //greatValueCards组件
        :deep(.test-card) {
          // width: 387px;
          margin-right: 10px;
          flex-shrink: 0 !important;
          // margin-bottom: 20px;
          .box-price {
            display: none;
          }
          // img {
          //   width: 119px;
          //   height: 159px;
          //   margin: 0 auto;
          // }
          //按钮隐藏
          .el-button.is-text.is-has-bg {
            display: none !important;
          }
        }

        :deep(.test-card):last-of-type {
          margin-right: 0px;
        }
      }
    }
    //亲子园地
    .box3 {
      width: 100%;
      // height: 503px;
      height: auto;

      // border: 1px solid transparent;
      // border: 1px solid rgb(58, 41, 212);
      // overflow: hidden;
      overflow: visible;
      .text-bar {
        margin-top: 20px;
      }

      /* 针对webkit内核浏览器 */
      .box3-content::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
        height: 0px;
      }

      .box3-content {
        width: 100%;
        height: auto;
        padding: 0px 16px;
        display: flex;

        overflow-x: auto;

        :deep(.big-box) {
          margin-right: 16px;
          flex-shrink: 0;
          // box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.0509803922);
          // border:1px solid rgba(217, 216, 216, 0.306);
          //  box-shadow:2px 2px 4px #c5cbce90;
          // border:1px solid red;
          .p3-research {
            font-size: 14px;
          }
        }
        :deep(.big-box):last-of-type {
          margin-right: 0px;
        }
      }
    }
  }

  :deep(.text-bar) {
    .check-more {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
